import axios from "axios";
import { Base_URL } from "../url";

export const fetchBanks = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/BankMaster/GetAllBanks/id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching banks!";
  }
};

export const downloadBanksExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/BankMaster/DownloadBanksExcel`,
      {}, 
      {
        responseType: 'blob' 
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading banks data!";
  }
};